<script setup lang="ts">
withDefaults(defineProps<{
  value: boolean,
  id: string,
  label?: string,
  labelPositive?: string,
  labelNegative?: string,
}>(), { labelPositive: 'Si', labelNegative: 'No' })

defineEmits(['change'])
</script>

<template>
  <!-- WCAG 4.1.2 — role="switch" e aria-checked comunicano stato agli screen reader -->
  <button
    :id="id"
    role="switch"
    :aria-checked="value"
    class="transition-container relative inline-flex h-8 w-24 items-center rounded-full bg-slate-200 focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2"
    @click="$emit('change', !value)"
  >
    <!-- WCAG 4.1.2 — usa label leggibile se fornita, altrimenti fallback all'id tecnico -->
    <span class="sr-only">{{ label || id }}</span>
    <span :class="[
      value
        ? 'bg-primary right-0 text-white'
        : 'left-0 bg-slate-300 text-slate-700',
    ]" class="absolute flex h-8 w-12 items-center justify-center rounded-full lg:w-16" aria-hidden="true">
      {{ value ? labelPositive : labelNegative }}
    </span>
  </button>
</template>
